import React from "react";
import QuestionCard from "../review/QuestionCard";
import AuthorReviewPanel from "../review/AuthorReviewPanel";
import DecisionPanel from "../review/DecisionPanel";
import StatusHistory from "../review/StatusHistory";

// The page of those who decide on a question: those its actions give a step (in its subject the experts,
// moderators and admins; outside folders the controllers). A moderator who wrote the question lands here too:
// they may only archive or restore it, and resubmit it when it comes back to them. Main reads the question and
// its history (useQuestionPage) and draws the top bar above; `reload` reads them again.
export default function ApproverPage({ question, history, historyLoading, historyFailed, reload, folderRole = null, canVote = false }) {
  return (
    <div className="mx-auto w-full max-w-5xl space-y-6 motion-safe:animate-fade-in 2xl:max-w-screen-2xl">
      <div className="grid grid-cols-1 items-start gap-6 2xl:grid-cols-2">
        <QuestionCard question={question} showVotes canVote={canVote} onVoted={reload} />

        <div className="space-y-6">
          <AuthorReviewPanel question={question} history={history} onChanged={reload} onReload={reload} />
          <DecisionPanel question={question} folderRole={folderRole} onChanged={reload} onReload={reload} />
          <StatusHistory
            history={history}
            loading={historyLoading}
            failed={historyFailed}
            authorUuid={question.author?.uuid}
          />
        </div>
      </div>
    </div>
  );
}
